module.exports = __webpack_public_path__ + "img/spark.da1868e0.gif";